import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { ForgotPasswordForm } from "@/features/auth/components/ForgotPasswordForm"
import { ResetPasswordForm } from "@/features/auth/components/ResetPasswordForm"
import { SuccessView } from "@/features/auth/components/SuccessView"
import { AuthLayout } from "@/features/auth/components/AuthLayout"
import { useState } from "react"

export const Route = createFileRoute("/auth/reset-password/")({
    component: ResetPasswordPage,
})

function ResetPasswordPage() {
    const navigate = useNavigate()
    const [step, setStep] = useState<'FORGOT' | 'RESET' | 'SUCCESS'>('FORGOT')
    const [email, setEmail] = useState("")

    return (
        <AuthLayout>
            {step === 'FORGOT' && (
                <ForgotPasswordForm
                    onSuccess={(email) => {
                        setEmail(email)
                        setStep('RESET')
                    }}
                />
            )}

            {step === 'RESET' && (
                <ResetPasswordForm
                    email={email}
                    onSuccess={() => setStep('SUCCESS')}
                />
            )}

            {step === 'SUCCESS' && (
                <SuccessView
                    title="Successful"
                    message="Congratulations! Your password has been changed. Click continue to login"
                    onContinue={() => navigate({ to: "/auth/login" })}
                />
            )}

            {step === 'FORGOT' && (
                <div className="mt-6 text-sm text-gray-600 text-center">
                    Remember your password? <button type="button" onClick={() => navigate({ to: '/auth/login' })} className="text-[#E86C31] hover:underline ml-1">Log in</button>
                </div>
            )}
        </AuthLayout>
    )
}
